import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/shared/services/home.service';
import { PerformanceTrackerService } from 'src/app/shared/services/performance-tracker.service';
import { VisibilityService } from 'src/app/shared/services/visibility.service';

@Component({
  selector: 'app-dashboard-suite',
  templateUrl: './dashboard-suite.component.html',
  styleUrls: ['./dashboard-suite.component.scss']
})
export class DashboardSuiteComponent implements OnInit {
  public study_id: string | null = null;
  public superSetSubMenuDashCardCont:any[] = [];
  public errorText: string = "No Dashboards Found";
  public studyName:string = "";
  constructor(
    private performanceTrackerService: PerformanceTrackerService,
    private visibilityService: VisibilityService,
    private router: Router,
    private route: ActivatedRoute,
    private homeService: HomeService
  ) { }

  ngOnInit(): void {
    this.study_id = this.route.snapshot.paramMap.get('id');
    this.getStudyDetails(this.study_id);
    this.getDashboardMenu(this.study_id);
    this.homeService.isOpen = false;
  }

  ngOnDestroy(): void {
    this.homeService.isOpen = true;
  }


  getStudyDetails(study_id: string | null):void{
    this.visibilityService.getStudyDetails(study_id).subscribe((res:any) => {
      if(res && res.status && res.studyName){
        this.studyName = res.studyName;
      }
    });
  }


  navigateTo(menu: any){
    if(menu && menu.heading && menu.uuid){
      localStorage.setItem('dash_suite_uuid', menu.uuid);
      this.router.navigate(['home/dash-suite', menu.heading.split(' ').join('-').toLowerCase(),this.study_id]);
    }
  }

  navigateToPerformanceTracker():void{
    this.router.navigate(['/home/performance-tracker',this.study_id]);
  }


  getDashboardMenu(study_id: string | null){
    this.superSetSubMenuDashCardCont = []
    this.performanceTrackerService.getStudyVisibility(study_id).subscribe((res:any) => {
      if(res && res.status && res.data){
         let parsedData = res.data;
          try {
            while (typeof parsedData === "string") {
              parsedData = JSON.parse(parsedData);
            }
            if(parsedData.hasOwnProperty('superset')) {
              let keys = Object.keys(parsedData.superset['els']) || [];
              keys.forEach((key: any) => {
                let menu = parsedData.superset['els'][key];
                if(menu && menu.show && menu.label && menu.uuid){
                  this.superSetSubMenuDashCardCont.push({
                    heading: menu.label,
                    uuid: menu.uuid,
                    desc: menu.desc
                  });
                }
              });
            }
          } 
          catch (e) {
            console.error('Error parsing visibility data', e);
          }
      }else{
        this.errorText = "No Dashboards Found";
      }
    })
  }
}
